import React, { useContext } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import SettingsContext from "./settingsContext";
import { useTranslation } from "react-i18next";
import useClasses from "../useClasses";

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

export default function Profile(props) {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  const { settings, handleChange } = useContext(SettingsContext);

  return (
    <div>
      <Container component="main" maxWidth={props.maxWidth}>
        <CssBaseline />
        <div className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                {t("account.privacy.subtitle")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(settings.makePublic)}
                    onChange={handleChange}
                    name={"makePublic"}
                    color="primary"
                  />
                }
                label={t("account.privacy.makePublic", {
                  code: `@${settings.code}`,
                })}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Boolean(settings.findOnName)}
                    onChange={handleChange}
                    name={"findOnName"}
                    color="primary"
                  />
                }
                label={t("account.privacy.findOnName")}
              />
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}
